// import $http from "@/api/fetch"
// import api from '@/api/api'
import store from './index'
import sys from './system'
//写cookies
function setCookie(name, value, time) {
  var strsec = getsec(time);
  var exp = new Date();
  exp.setTime(exp.getTime() + strsec * 1);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}
//s20是代表20秒
//h是指小时，如12小时则是：h12
//d是天数，30天则：d30
function getsec(str) {
  var str1 = str.substring(1, str.length) * 1;
  var str2 = str.substring(0, 1);
  if (str2 == "s") {
    return str1 * 1000;
  } else if (str2 == "h") {
    return str1 * 60 * 60 * 1000;
  } else if (str2 == "d") {
    return str1 * 24 * 60 * 60 * 1000;
  }
}
//读取cookies
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);
  else return null;
}
//删除cookies
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}


/**
 * 登录，退出操作
 **/
const user = {
  state: {
    userInfo: localStorage.getItem(sys.state._storage + 'userInfo') ? JSON.parse(localStorage.getItem(sys.state._storage +
      'userInfo')) : {},
    // 新闻详情id
    newsId: localStorage.getItem(sys.state._storage + 'newsId') ? localStorage.getItem(sys.state._storage +
      'newsId') : 0,
    // loginStatus: localStorage.getItem(sys.state._storage + 'login') ? localStorage.getItem(sys.state._storage +
    //   'login') : false, //是否登录
    loginStatus: localStorage.getItem(sys.state._storage + 'login') && getCookie(sys.state._storage + 'login') ?
      getCookie(sys.state._storage +
        'login') : false, //是否登录
    loginShow: false, //登录框是否显示
    navClick: false //是否点击了个人中心按钮
  },
  mutations: {
    // 登录
    LOGING_STATE: (state, userInfo) => {
      state.userInfo = JSON.parse(localStorage.getItem(sys.state._storage + 'userInfo'));
      state.loginStatus = true;
    },
    // 切换新闻详情id
    CHANGE_NEWS: (state, value) => {
      state.newsId = value;
      localStorage.setItem(sys.state._storage + "newsId", value);
    },
    // 切换登录与否
    CHANGE_LOGIN: (state, value) => {
      state.loginStatus = false;
      state.userInfo = {};
      localStorage.removeItem(sys.state._storage + 'userInfo');
      localStorage.removeItem(sys.state._storage + 'login');
      delCookie(sys.state._storage + 'login');
    },
    // 切换登录显示状态
    CHANGE_LOGIN_SHOW: (state, value) => {
      state.loginShow = value;
    },
    // 切换是否点击了个人中心
    CHANGE_MY: (state, value) => {
      state.navClick = value;
    },
  },
  actions: {
    //登录异步操作
    userLogin({
      commit
    }, value) {
      localStorage.setItem(sys.state._storage + 'userInfo', JSON.stringify(value));
      localStorage.setItem(sys.state._storage + 'login', true);
      setCookie(sys.state._storage + 'login', true, 'd7');
      commit('LOGING_STATE', value);
    },
    // 切换新闻详情id
    setNewsId({
      commit
    }, value) {
      commit('CHANGE_NEWS', value);
    },
    // 登录
    LOGOUT({
      commit
    }, value) {
      commit('CHANGE_LOGIN', value);
    },
    // 登录框显示与隐藏
    LOGINSHOW({
      commit
    }, value) {
      commit('CHANGE_LOGIN_SHOW', value);
    },
    // 个人中心是否点击
    MYSET({
      commit
    }, value) {
      commit('CHANGE_MY', value);
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js